/* ============================================================
   3. MODIFICATION DES COLOR SWATCH (FLÈCHE DE SCROLL)
   ============================================================ */

const SVG_RIGHT = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#793f0d" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>`;
const SVG_LEFT = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#793f0d" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>`;

function simpleSwatchCount() {
  // On cible uniquement le bloc qui contient les couleurs
  const colorContainer = document.querySelector(".variant-picker__options:has(.swatches)");
  
  if (!colorContainer) return;

  const rail = colorContainer.querySelector(".variant-picker__option-values");
  const labelHeader = colorContainer.querySelector(".variant-picker__option-name") || colorContainer.querySelector("label");
  
  // On compte strictement les billes (les éléments 'label' dans .swatches)
  const numberOfSwatches = colorContainer.querySelectorAll(".swatches label").length;

  const existingBtn = colorContainer.querySelector(".swatch-scroll-btn");

  // LOGIQUE DE COMPTAGE : Si 9 ou moins (comme tes 8 couleurs Daim), on vire la flèche
  if (numberOfSwatches <= 9) {
    if (existingBtn) existingBtn.remove();
    return;
  }

  // Si plus de 9, on gère la flèche
  if (!existingBtn) {
    const btn = document.createElement("span");
    btn.className = "swatch-scroll-btn";
    btn.innerHTML = SVG_RIGHT;
    labelHeader.appendChild(btn);

    let atStart = true;
    btn.onclick = (e) => {
      e.preventDefault();
      atStart = !atStart;
      rail.scrollBy({ left: atStart ? -250 : 250, behavior: "smooth" });
      btn.innerHTML = atStart ? SVG_RIGHT : SVG_LEFT;
    };
  }
}

// On verrouille à 10ms pour une réactivité maximale
setInterval(simpleSwatchCount, 10);




/* ============================================================
   2. bordure miniature active slider pc
   ============================================================ */

document.addEventListener('click', function (event) {
  const thumbnail = event.target.closest('.product-media-gallery__thumbnail');

  if (!thumbnail) return;

  const thumbnails = thumbnail.closest('.product-media-gallery__thumbnails');

  if (!thumbnails) return;

  thumbnails.querySelectorAll('.product-media-gallery__thumbnail').forEach(function (slide) {
    slide.classList.remove('is-active');
    slide.removeAttribute('aria-current');
  });

  thumbnail.classList.add('is-active');
  thumbnail.setAttribute('aria-current', 'true');
});